var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAdmissionsIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 44 44",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#admissions-icon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M43.5 22c0 11.874-9.626 21.5-21.5 21.5S.5 33.874.5 22 10.126.5 22 .5 43.5 10.126 43.5 22Z",
  stroke: "#A4ABB7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.45 23.4c-.56 0-1.71-.21-2.5-1.01-.91-.91-1.19-2.06-.76-3.1.4-.97 1.37-1.62 2.41-1.62 1.13 0 2.16 1.01 2.16 2.11 0 .28-.22.5-.5.5s-.5-.22-.5-.5c0-.56-.58-1.11-1.16-1.11-.64 0-1.23.4-1.48 1-.27.66-.07 1.39.54 2.01.56.56 1.42.71 1.79.71 2.48 0 3.37-1.85 3.37-3.58 0-1.97-1.89-3.58-4.22-3.58H13.41c-2.33 0-4.22 1.61-4.22 3.58 0 1.73.88 3.58 3.37 3.58.37 0 1.23-.15 1.79-.71.62-.62.82-1.35.55-2.01-.25-.6-.84-1-1.48-1-.59 0-1.16.55-1.16 1.11 0 .28-.22.5-.5.5s-.5-.22-.5-.5c0-1.11 1.03-2.11 2.16-2.11 1.04 0 2 .65 2.4 1.62.43 1.03.14 2.19-.76 3.1-.79.79-1.95 1.01-2.5 1.01-2.65 0-4.37-1.8-4.37-4.58 0-2.53 2.34-4.58 5.22-4.58h17.18c2.88 0 5.22 2.05 5.22 4.58 0 2.78-1.71 4.58-4.37 4.58h.01ZM33.6 13.09h-2.58c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h2.08v-1.15H10.9v1.15h2.08c.28 0 .5.22.5.5s-.22.5-.5.5H10.4c-.28 0-.5-.22-.5-.5v-2.15c0-.28.22-.5.5-.5h23.19c.28 0 .5.22.5.5v2.15c0 .28-.22.5-.5.5h.01Z",
  fill: "#5C6471"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.59 15.24H13.41s-.08 0-.12-.01c-.09-.02-2.1-.54-2.1-2.2 0-.28.22-.5.5-.5s.5.22.5.5c0 .78 1.04 1.14 1.29 1.22h17.04c.25-.08 1.29-.44 1.29-1.22 0-.28.22-.5.5-.5s.5.22.5.5c0 1.66-2.01 2.18-2.1 2.2-.04 0-.08.01-.12.01Z",
  fill: "#5C6471"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.72 18.68h-9.45c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h9.45c.28 0 .5.22.5.5s-.22.5-.5.5Z",
  fill: "#A4ABB7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.74 13.09H15.26c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h13.49c.28 0 .5.22.5.5s-.22.5-.5.5h-.01Z",
  fill: "#F15B35"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.41 36.72c-.28 0-.5-.22-.5-.5V22.91c0-.28.22-.5.5-.5s.5.22.5.5v13.31c0 .28-.22.5-.5.5Z",
  fill: "#5C6471"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22 36.72c-.28 0-.5-.22-.5-.5V23.34c0-.28.22-.5.5-.5s.5.22.5.5v12.88c0 .28-.22.5-.5.5ZM26.29 36.72c-.28 0-.5-.22-.5-.5V23.34c0-.28.22-.5.5-.5s.5.22.5.5v12.88c0 .28-.22.5-.5.5Z",
  fill: "#A4ABB7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.59 36.72c-.28 0-.5-.22-.5-.5V22.91c0-.28.22-.5.5-.5s.5.22.5.5v13.31c0 .28-.22.5-.5.5Z",
  fill: "#5C6471"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.7 36.72c-.28 0-.5-.22-.5-.5V23.34c0-.28.22-.5.5-.5s.5.22.5.5v12.88c0 .28-.22.5-.5.5ZM25.869 21.25h-7.73c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h7.73c.28 0 .5.22.5.5s-.22.5-.5.5Z",
  fill: "#A4ABB7"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "admissions-icon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h44v44H0z"
})))));
export default SvgAdmissionsIcon;